import React from "react";
import { motion } from "framer-motion";
import { IMAGES, Reveal, Eyebrow, EASE } from "./shared";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 lg:py-40"
      style={{ backgroundColor: "#FAF9F7" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Image left */}
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal className="relative overflow-hidden rounded-sm" style={{ aspectRatio: "4/5" }}>
            <motion.img
              src={IMAGES.about}
              alt="Street and architecture in the Silvassa region"
              className="w-full h-full object-cover"
              initial={{ scale: 1.15 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: EASE }}
            />
          </Reveal>
        </div>

        {/* Text */}
        <div className="lg:col-span-7 order-1 lg:order-2 lg:pl-8">
          <Reveal><Eyebrow>About Fortim</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-bold leading-[1.08] text-3xl sm:text-4xl lg:text-5xl" style={{ color: "#2B2B2B" }}>
              Built on Local Insight.<br />
              <span style={{ color: "#3B2C82" }}>Driven by Long-Term Vision.</span>
            </h2>
          </Reveal>
          <div className="mt-8 space-y-5 max-w-2xl text-base lg:text-lg leading-relaxed" style={{ color: "#2B2B2B" }}>
            <Reveal delay={0.1} as="p">
              Fortim Ventures was founded on a simple belief: every market has
              unique opportunities waiting to be unlocked.
            </Reveal>
            <Reveal delay={0.15} as="p">
              Rather than applying a one-size-fits-all approach, we build businesses, brands and
              partnerships specifically tailored to the characteristics of DNHDD.
            </Reveal>
            <Reveal delay={0.2} as="p" >
              <span style={{ color: "#8C8C8C" }}>
                Our strength lies in understanding the region, building lasting relationships and
                executing with consistency.
              </span>
            </Reveal>
            <Reveal delay={0.25} as="p">
              <span className="font-medium" style={{ color: "#3B2C82" }}>
                While our journey begins here, our ambition reaches far beyond it.
              </span>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
